import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { catchError, map, of } from 'rxjs';

import { AccessPolicyService } from '../services/access-policy.service';
import { FeatureFlagService } from '../services/feature-flag.service';

/** Consolidated submission can expose locked financial evidence only to invoice approvers. */
export const consolidatedMyInvoisApprovalGuard: CanActivateFn = () => {
  const accessPolicy = inject(AccessPolicyService);
  const router = inject(Router);
  const featureFlagService = inject(FeatureFlagService);

  return featureFlagService.getCurrentFlags().pipe(
    map((flags) => flags['CONSOLIDATED_MYINVOIS'] === true && accessPolicy.canApproveInvoices()
      ? true
      : router.createUrlTree(['/dashboard'])),
    catchError(() => of(router.createUrlTree(['/dashboard'])))
  );
};
